export const environment = {
  production: false,

  //  existing configs
  // apiUrl: 'https://dev-api-v2.wareed.com.sa/',
  apiUrl: 'https://wareed-api-revamp.vproj.com/',
  // apiSlug: 'api/cms/',
  // apiSlug: 'api/v1/api-gateway/',
  // imageUrl: 'https://dev-api-v2.wareed.com.sa/images/',
  imageUrl: 'https://wareedlabs-dev.fra1.cdn.digitaloceanspaces.com/',
  fileUrl: '',
  defaultPlaceholder: '/images/default_placeholder.png',
  otp_time: 10, // seconds
  otp_timer_value: '00:10',
  dateFormat: 'DD, MMMM YYYY',
  dateMonthFormat: 'DD MMMM',
  dateFormatTable: 'MMM d, y',

  googleMapsKey: '',
  xAccessToken: '',
  //  firebase config
  firebase: {
    apiKey: '',
    authDomain: '',
    projectId: '',
    storageBucket: '',
    messagingSenderId: '',
    appId: '',
    measurementId: '',
    vapidKey: '',
  },
};
